<template>
    <div>
        <main-header :userProfileData = "userProfileData"></main-header>
        <div class="container-fluid">
            <div class="row row-flush-viewport-100">
                <!--LEFT COLUMN START-->
                <div id="search-details-enter" class="col-md-4 col-flush-viewport-left">
                    <div class="row no-gutters" id="search-form-container">
                        <div class="col-12">
                            <div class="row no-gutters bg-white shadow-sm">
                                <div class="col-12 py-1 pl-3 bg-primary text-white">
                                    <h1>Find or Start a New Quote</h1>
                                </div>
                                <div id="form-container" role="main" class="mt-2 add-scroll-y">
                                    <form class="needs-validation" id="searchForm" novalidate action="self">
                                        <!-- CONFIRM & CONSENT NOTICE -->
                                        <div class="d-flex justify-content-center mx-auto my-3 w-100">
                                          <div class="alert alert-warning  w-100" role="note">
                                            <div class="row no-gutters">
                                              <div class="d-inline-block pr-2">
                                                <img width="20px" height="20px" src="../assets/exclamation-circle-yellow-new.svg" alt="info">
                                              </div>
                                              <div class="col d-inline-block my-auto smaller-font-content">
                                                <p class="mb-0 text-dark-gray"><strong>Prior to gathering information from the customer, please read the following statement:</strong> <br>"I’ll be submitting your information to insurance carriers I represent who will provide you with a notice describing their privacy policies and practices once an insurance policy has been established."</p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <fieldset class="px-3 py-1 border boarder-primary rounded">
                                            <legend class="px-1 mb-0 w-auto text-primary smaller-font-content">
                                                <div role="heading" aria-level="3"><strong>FIND</strong> Quotes & Policies</div>
                                            </legend>
                                            <div class="row" @mousedown.capture="clearMessages('emailOrPhone')">
                                                <div class="col-12 col-xl-8 form-group">
                                                    <label for="emailOrPhone">Email or Phone Number</label>
                                                    <div class="input-group" style="width:95%;max-width:100%">
                                                      <input
                                                      name="emailOrPhone"
                                                      id="emailOrPhone"
                                                      type="text"
                                                      ref="emailOrPhone"
                                                      placeholder="Email Address / Phone Number"
                                                      v-model.trim="formData.ep"
                                                      v-bind:class="{'form-control': true, 'error': errors.has('emailOrPhone') }">
                                                      <span v-bind:class="{'fas fa-exclamation-triangle': errors.has('emailOrPhone') }"></span>
                                                    </div>
                                                    <div v-show="errors.has('emailOrPhone')" class="text-danger">
                                                      {{ errors.first('emailOrPhone') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset class="px-3 py-1 mt-3 border rounded">
                                            <legend class="px-1 mb-0 w-auto smaller-font-content">
                                              <div role="heading" aria-level="3"><strong>OR</strong> Find/Start A Quote <span class="qrp-text-muted">(<span class="star">*</span>Required for new quotes.)</span></div>
                                            </legend>

                                            <input-product-type :insuranceType="insuranceType"></input-product-type>
                                            <div class="row" @mousedown.capture="clearMessages('zipcode')">
                                                <div class="col col-lg col-xl-10 form-group w-75">
                                                    <label for="zipcode">Zip Code<span class="star">*</span></label>
                                                    <div class="input-group" style="width:35%;max-width:100%">
                                                      <input
                                                      name="zipcode"
                                                      id="zipcode"
                                                      type="text"
                                                      ref="zipcode"
                                                      :disabled="showEpicBehaviors"
                                                      v-validate="'digits:5'"
                                                      v-model="formData.zip" maxlength="5"
                                                      v-mask="'#####'"
                                                      size="5"
                                                      class="std-width form-control"
                                                      v-bind:class="{'form-control': true, 'error': errors.has('zipcode') }">
                                                      <span v-bind:class="{'fas fa-exclamation-triangle': errors.has('zipcode') }"></span>
                                                    </div>
                                                    <div v-show="errors.has('zipcode')" class="text-danger">
                                                        {{ errors.first('zipcode') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" @mousedown.capture="clearMessages('fname')">
                                                <div class="col-12 col-xl-8 form-group">
                                                    <label for="fname">First Name</label>
                                                    <div class="input-group" style="width:95%;max-width:100%">
                                                      <input
                                                      name="fname"
                                                      id="fname"
                                                      ref="fname"
                                                      :disabled="showEpicBehaviors"
                                                      aria-describedby="help-fname"
                                                      type="text"
                                                      v-validate="{ regex: /^[a-zA-Z-' ]+$/ }"
                                                      v-model="formData.fname"
                                                      v-bind:class="{'form-control': true, 'error': errors.has('fname') }">
                                                      <span v-bind:class="{'fas fa-exclamation-triangle': errors.has('fname') }"></span>
                                                    </div>
                                                    <div v-show="errors.has('fname')" class="text-danger">
                                                        {{ errors.first('fname') }}
                                                    </div>
                                                     <div id="help-fname" class="form-text qrp-text-muted smaller-font-content">Must be used with
                                                        <strong>Last Name</strong>.</div>
                                                </div>
                                            </div>

                                            <div class="row" @mousedown.capture="clearMessages('lname')">
                                                <div class="col-12 col-xl-8 form-group">
                                                    <label for="lname">Last Name</label>
                                                    <div class="input-group" style="width:95%;max-width:100%">
                                                      <input
                                                      name="lname"
                                                      id="lname"
                                                      ref="lname"
                                                      :disabled="showEpicBehaviors"
                                                      type="text"
                                                      v-validate="{ regex: /^[a-zA-Z-' ]+$/ }"
                                                      v-model="formData.lname"
                                                      v-bind:class="{'form-control': true, 'error': errors.has('lname') }">
                                                      <span v-bind:class="{'fas fa-exclamation-triangle': errors.has('lname') }"></span>
                                                    </div>
                                                    <div v-show="errors.has('lname')" class="text-danger">
                                                        {{ errors.first('lname') }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row" @mousedown.capture="clearMessages('dob_masked')">
                                                <div class="col col-lg col-xl-10 form-group w-75">
                                                    <label for="dob_masked">Date of Birth</label>
                                                    <div class="input-group" style="width:43%;max-width:100%">
                                                      <the-mask
                                                      name="dob_masked"
                                                      id="dob_masked"
                                                      ref="dob"
                                                      type="text"
                                                      placeholder="MM/DD/YYYY"
                                                      v-model="formData.dob" mask="##/##/####"
                                                      v-validate="'date_format:MM/DD/YYYY|within_year_range:108,16,MM/DD/YYYY'"
                                                      size="10"
                                                      :masked="true"
                                                      v-bind:class="{'std-width form-control': true, 'error': errors.has('dob') }">
                                                      </the-mask>
                                                      <input
                                                      v-show="false"
                                                      name="dob"
                                                      type="text"
                                                      v-validate="'date_format:MM/DD/YYYY|within_year_range:108,16,MM/DD/YYYY'"
                                                      v-model="dob_masked_input_value"
                                                      v-bind:class="{'form-control': true, 'error': errors.has('dob') }">
                                                      <span v-bind:class="{'fas fa-exclamation-triangle': errors.has('dob') }"></span>
                                                    </div>
                                                    <div v-show="errors.has('dob')" class="text-danger">
                                                        {{ errors.first('dob') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <!--API ERROR MESSAGE-->
                                        <div v-show="createQuoteErrs.length" class="small my-3 p-2 form-error">
                                            <span v-for="(errData, ekey) in createQuoteErrs" :key='ekey'>
                                                <strong>Error:</strong> {{ errData.Message }}</span>
                                        </div>

                                        <div v-if="custom_error_message" class="small my-3 p-2 form-error">
                                            <span>
                                                <strong>Error:</strong> {{ custom_error_message }}</span>
                                        </div>

                                        <!--FORM BUTTONS-->
                                        <div id="form-button-container" class="form-group mt-3">
                                            <button type="submit" class="btn btn-success d-inline-block mr-3 epic-submit" v-if="showEpicBehaviors" @click.prevent="epicSubmit">Continue Epic Quote</button>
                                            <button type="submit" class="btn btn-primary d-inline-block mr-3" @click.prevent="findQuote">Find Quote</button>
                                            <button type="button" @click.prevent="submitted" class="btn btn-outline-primary d-inline-block mr-3">New Quote</button>
                                            <div class="d-inline-block mt-2">
                                                <a href="JavaScript:void(0);" @click.prevent="resetForm" id="clear-search" class="d-inline-block smaller-font-content qrp-text-link">Clear Search Fields</a>
                                            </div>
                                        </div>

                                        <div class="row mt-3">
                                            <main-footer id="main-footer" role="contentinfo"></main-footer>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--LEFT COLUMN END-->

                <!--RIGHT COLUMN START-->
                <div class="col-md-8 col-flush-viewport-right">
                    <div class="row no-gutters bg-white shadow-sm" id="search-results-list">

                        <div id="search-results-stick-head-columns">
                            <!--Section Head-->
                            <div class="col-12 py-1 bg-primary text-white text-center">
                                <h1>Search Results</h1>
                            </div>
                            <!--TABLE START-->
                            <!--Table Headers-->
                            <div class="col-12 pt-2 pb-1 bg-white pl-0" style="border-bottom: 1px solid #ebebeb;" id="search-results-list-header">
                                <div class="row mx-0 smaller-font-content font-weight-bold">
                                    <div class="col-1 mx-w-ico text-center">
                                      <span class="fas fa-archive"></span>
                                    </div>
                                    <div class="col-3 col-lg-3">
                                        <span>Named Insured</span>
                                    </div>
                                    <div class="col-3 col-lg-2">
                                        <span>Quote</span>
                                    </div>
                                    <div class="col-3 col-lg-2">
                                        <span>Provider</span>
                                    </div>
                                    <div class="col-2 col-lg-2">
                                        <span>Progress</span>
                                    </div>
                                    <div class="col"></div>
                                </div>
                            </div>
                        </div>

                        <div id="search-results-stick-body">
                            <!-- If search returns nothing -->
                            <div v-if="showEmptyMsg" class="pt-3 w-100">
                                <p class="qrp-text-muted text-center smaller-font-content">{{ zeroRecMsg }}</p>
                            </div>

                            <!-- for every search result returned -->
                            <div v-for="(sItem, sKey) in searchResultData.data" :key='sKey' v-if="!showEmptyMsg" class="col-12 pb-0 mb-row-custom pl-0"
                            :class="{ 'row-auto-bg': sItem.ProductTypeId === 1, 'row-home-bg': sItem.ProductTypeId === 21, 'row-condo-bg': sItem.ProductTypeId === 18, 'row-renter-bg': sItem.ProductTypeId === 12, 'row-home-auto-bundle-bg': getFlowType(sItem) ===  'bundle', 'row-condo-auto-bundle-bg': getFlowType(sItem) ===  'cabundle', 'row-renter-auto-bundle-bg': getFlowType(sItem) ===  'rabundle'}">
                                <div class="row mx-0 smaller-font-content">
                                    <div class="col-1 py-5 mx-w-ico search-row-common auto px-0" v-if="sItem.ProductTypeId === 1"><div class=""><span class="fas fa-car"></span></div></div>
                                    <div class="col-1 py-5 mx-w-ico search-row-common home px-0" v-if="sItem.ProductTypeId === 21"><div class=""><span class="fas fa-home"></span></div></div>
                                    <div class="col-1 py-5 mx-w-ico search-row-common condo px-0" v-if="sItem.ProductTypeId === 18"><div class=""><span class="fas fa-hotel"></span></div></div>
                                    <div class="col-1 py-5 mx-w-ico search-row-common renter px-0" v-if="sItem.ProductTypeId === 12"><div class=""><span class="fas fa-building"></span></div></div>
                                    <div class="col-1 py-5 mx-w-ico search-row-common home-auto-bundle px-0" v-if="getFlowType(sItem) ===  'bundle'"><div class=""><span class="fas fa-home-auto-bundle-search"></span></div></div>
                                    <div class="col-1 py-5 mx-w-ico search-row-common condo-auto-bundle px-0" v-if="getFlowType(sItem) ===  'cabundle'"><div class=""><span class="fas fa-condo-auto-bundle-search"></span></div></div>
                                    <div class="col-1 py-5 mx-w-ico search-row-common renter-auto-bundle px-0" v-if="getFlowType(sItem) ===  'rabundle'"><div class=""><span class="fas fa-renter-auto-bundle-search"></span></div></div>
                                    <div class="col-3 pt-4 col-lg-3 text-wrap">
                                        <span class="font-weight-bold">{{ sItem.FirstName +' '+ sItem.LastName }}</span>
                                        <br/>
                                        <span>{{ sItem.Email }}</span>
                                        <br/>
                                        <span>P. {{ formatPhoneNumber(sItem.PhoneNumber) }}</span>
                                        <br/>
                                        <span>{{ucWords(sItem.City)}}, {{ sItem.State +' '+ sItem.ZipCode}}</span>
                                    </div>
                                    <div class="col-3 pt-4 col-lg-2">
                                        <span class="font-weight-bold">{{getProductName(sItem)}} Insurance</span>
                                        <br/>
                                        <span>{{ getDateFormat(sItem.LastAccessedDate) }}</span>
                                        <br/>
                                        <span class="qrp-text-muted">({{ getDayDifference(sItem.LastAccessedDate) }} Days Ago)</span>
                                        <br/>
                                    </div>
                                    <div class="col-3 pt-4 col-lg-2">
                                        <span class="font-weight-bold">{{ sItem.CustomerProviderName }}</span>
                                    </div>
                                    <div class="col-2 pt-4 col-lg-2">
                                        <span class="font-weight-bold">{{ sItem.ProgressDisplayValue }}</span>
                                    </div>
                                    <div class="col pt-4 py-md-3 align-middle text-center">
                                        <button type="button" class="btn btn-primary" @click="processQuote({ qId: sItem.SessionId }, sItem)">Open Quote</button>
                                    </div>
                                </div>
                            </div>
                            <!--TABLE END-->
                        </div>
                    </div>
                </div>
                <!--RIGHT COLUMN END-->
            </div>
        </div>
        <div v-if="epicSuccess" class="alert alert-success alert-dismissible fade show epic-success" role="alert">
          <div class="row">
            <div class="d-inline-block float-left align-self-center mx-2 text-center">
              <span class="fas fa-check-circle epic-alert-icon"></span>
            </div>
            <div class="col px-0 d-inline-block">
              <h4>Success: Customer Information Prefilled!</h4>
              <p>The EPIC customer's information has been prefilled. Proceed with the “Continue w/ EPIC Quote” button.</p>
            </div>
          </div>
        </div>
        <div v-if="epicFailure" class="alert alert-danger alert-dismissible fade show epic-failure" role="alert">
          <div class="row">
            <div class="d-inline-block float-left align-self-center mx-2 text-center">
              <span class="fas fa-exclamation-circle epic-alert-icon"></span>
            </div>
            <div class="col px-0 d-inline-block">
              <h4>Error: Customer Information Prefill Failed!</h4>
              <p>The customer information was not prefilled. Please try again by going back to EPIC, or proceed with a new quote.</p>
            </div>
          </div>
        </div>
        <div v-if="epicSubmitFailure" class="alert alert-danger alert-dismissible fade show epic-failure" role="alert">
          <div class="row">
            <div class="d-inline-block float-left align-self-center mx-2 text-center">
              <span class="fas fa-exclamation-circle epic-alert-icon"></span>
            </div>
            <div class="col px-0 d-inline-block">
              <h4>Error: Customer Quote Import Failed!</h4>
              <p>The customer quote information was not imported. Please try again by using the “Continue w/ EPIC Quote” button.</p>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import User from '@/services/User';
import moment from 'moment';
import Header from './shared/Header';
import Footer from './shared/Footer';
import InputProductType from './interactive/InputProductType';
import { stickyDivMixin } from '../mixins/stickyDivMixin';
import FormBlock from './presentational/FormBlock';
import fetchData from '../services/fetchData';
import postData from '../services/postData';
import actions from '../services/actions';
import commonService from '../services/common';
import axios from '../axios-config';
import filters from '../../config/admin/filters';
import QRP from '../../config/QRP.env';
import { quoteMixin } from '../mixins/quoteMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  mixins: [stickyDivMixin, quoteMixin],
  props: [
    'forceBindData',
    'qId',
    'loc',
  ],
  data() {
    return {
      masked_input: '', // Holds the masked input value outside of the computed property to avoid an infinite loop
      dob_masked_input: '',
      showEpicBehaviors: false,
      epicSuccess: false,
      epicFailure: false,
      epicSubmitFailure: false,
      formData: {
        fname: '',
        lname: '',
        ep: '',
        zip: '',
        dob: '',
        email: '',
        phone: '',
        productType: '',
      },
      searchResultData: '',
      createQuoteErrs: [],
      custom_error_message: '',
      showEmptyMsg: false,
      zeroRecMsg: '', // Submission validation needs custom messaging depending on user input
      userAgency: '',
      productButtonsData: {},
      insuranceType: {
        field_name: 'insurance_type',
        label: 'Product',
        field_value: '',
        rules: [],
        field_type: 'text',
        help_text: '',
        values: [],
        is_required: true,
        is_enabled: true,
        visible: true,
        placeholder: null,
        sub_text: null,
        multi_select: false,
      },
      userProfileData: { firstName: '', lastName: '' },
    };
  },
  computed: {
    /**
     * Uses data property `masked_input` to store the input field's value without masked characters
     * added. A separate property needs to be used otherwise the computed property would keep updating
     * itself and end up in an infinite loop!
     */
    /* eslint object-shorthand:  */
    /* eslint func-names: [0] */
    masked_input_value: {
      get: function () {
        return this.masked_input;
      },
      set: function (newValue) {
        this.masked_input = newValue;
        this.formData.phone = this.masked_input;
      },
    },
    dob_masked_input_value: {
      get: function () {
        return this.dob_masked_input;
      },
      set: function (newValue) {
        this.dob_masked_input = newValue;
        this.formData.dob = this.dob_masked_input;
      },
    },
  },
  /* eslint prefer-arrow-callback:  */
  methods: {
    getFlowType(cItem) {
      let productTypeID = 0;
      if (cItem.QuoteBundle && cItem.QuoteBundle.details) {
        for (let i = 0; i < cItem.QuoteBundle.details.length; i += 1) {
          if (cItem.QuoteBundle.details[i].productTypeId !== QRP.PRODUCTS.AUTO) {
            if (cItem.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.HOME) {
              productTypeID = 'bundle';
            } else if (cItem.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.CONDO) {
              productTypeID = 'cabundle';
            } else if (cItem.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.RENTERS) {
              productTypeID = 'rabundle';
            }
          }
        }
      }
      return productTypeID;
    },
    /**
     * return product name
     */
    getProductName(cItem) {
      let productId = cItem.ProductTypeId;
      let pName = '';
      if (productId === 18) {
        pName = 'Condo';
      } else if (productId === 12) {
        pName = 'Renters';
      } else if (productId === 21) {
        pName = 'Home';
      } else if (productId === 1) {
        pName = 'Auto';
      } else if (productId === 0) {
        for (let i = 0; i < cItem.QuoteBundle.details.length; i += 1) {
          if (cItem.QuoteBundle.details[i].productTypeId !== QRP.PRODUCTS.AUTO) {
            if (cItem.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.HOME) {
              pName = 'Home + Auto';
            } else if (cItem.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.CONDO) {
              pName = 'Condo + Auto';
            } else if (cItem.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.RENTERS) {
              pName = 'Renters + Auto';
            }
          }
        }
      }
      return pName;
    },
    // TODO: Abstract into helper class
    /**
     * The validation message overlaps the interactive form element, so it is cleared
     * once the components containing the element is clicked.
     */
    clearMessages(fieldName) {
      this.formData.has_error = false; // Reset API errors to false upon any interaction
      this.errors.remove(fieldName); // Temporarily hide the validation message
    },
    setSearchStickies() {
      // will the left-side form section ever be smaller in height than page fold? maybe on bigger screens
      this.applyStickyByID('search-form-container');

      const stickyDivHeightObject = document.getElementById('search-results-list');

      const stickyHeightContOffsetHeight = stickyDivHeightObject.offsetHeight;
      const windowHeightMinusHeader = window.innerHeight - document.getElementById('header-logo-buttons').offsetHeight;

      if (stickyHeightContOffsetHeight > windowHeightMinusHeader) {
        document.getElementById('search-results-list').classList.remove('search-results-all-fixed');

        document.getElementById('search-results-stick-head-columns').classList.add('head-stick-head');
        document.getElementById('search-results-stick-body').classList.add('head-stick-body');
      } else {
        document.getElementById('search-results-stick-head-columns').classList.remove('head-stick-head');
        document.getElementById('search-results-stick-body').classList.remove('head-stick-body');

        document.getElementById('search-results-list').classList.add('search-results-all-fixed');
      }
    },
    ucWords(str) {
      let finalStr = '';
      let lower = str.toLowerCase();
      lower.replace(/\w\S*/g, function (word) {
        finalStr += ` ${word.charAt(0).toUpperCase()}${word.substr(1).toLowerCase()}`;
      });
      return finalStr;
    },
    /* format phone number to display in  XXX-XXX-XXXX format */
    formatPhoneNumber(phoneNumber) {
      let pn = (phoneNumber).replace(/\D/g, '');
      let m = pn.match(/^(\d{3})(\d{3})(\d{4})$/);
      return (!m) ? null : `${m[1]}-${m[2]}-${m[3]}`;
    },
    /**
     * Validating all of the fields on the validation event (ex: blur) is necessary to manually call
     * if there are masked inputs. This is because masked inputs use a custom component that do not
     * react to it's parent's events.
     *
     * TODO: Refactor masked inputs to pass their validation event to their input child
     */
    validate_all_fields() {
      this.$validator.validateAll();
    },
    async processQuote(permalinkRequest, item) {
      sessionStorage.removeItem('autobound');
      sessionStorage.removeItem('homebound');
      sessionStorage.removeItem('selectedQuote');
      sessionStorage.removeItem('flowType');
      sessionStorage.removeItem('currentNav');
      sessionStorage.removeItem('homeSessionData');
      sessionStorage.removeItem('condoSessionData');
      sessionStorage.removeItem('renterSessionData');
      sessionStorage.removeItem('autoSessionData');
      sessionStorage.removeItem('setRc2NavFlowAction');
      sessionStorage.removeItem('autoRC1BindResponse');
      sessionStorage.removeItem('checkoutNav');
      sessionStorage.removeItem('autoPageName');
      sessionStorage.removeItem('homeRC2pagename');
      sessionStorage.removeItem('selectedCarrierAuto');
      sessionStorage.removeItem('selectedCarrierHome');
      sessionStorage.removeItem('autoBindDetails');
      sessionStorage.removeItem('homeBindDetails');

      this.$store.dispatch('setForceBindSuccessful', false);
      // add current action in session storage to manage quote summary modal behavior
      sessionStorage.setItem('currentActionName', 'FormSubmit');
      sessionStorage.setItem('quoteSummaryStatus', 'visible');

      if (item.QuoteBundle !== null) {
        sessionStorage.setItem('selectedQuote', JSON.stringify(item));
        let flowType = this.getFlowType(item);
        sessionStorage.setItem('flowType', flowType);
        let sessionData = JSON.parse(sessionStorage.getItem('selectedQuote'));
        for (let i = 0; i < item.QuoteBundle.details.length; i += 1) {
          sessionData.ProductTypeId = item.QuoteBundle.details[i].productTypeId;
          sessionData.SessionId = item.QuoteBundle.details[i].quoteId;
          if (item.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.AUTO) {
            if (item.QuoteBundle.details[i].quote_status === 'Bound') {
              sessionStorage.setItem('autobound', true);
            }
            let autPermalinkRequest = {qId : item.QuoteBundle.details[i].quoteId};
            await actions.goToBundleQuote(autPermalinkRequest, this.$store, this.$router, 'auto');
            sessionStorage.setItem('autoSessionData', JSON.stringify(sessionData));
          } else {
            if (item.QuoteBundle.details[i].quote_status === 'Bound') {
              sessionStorage.setItem('homebound', true);
            }            
            if (item.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.HOME) {              
              sessionStorage.setItem('homeSessionData', JSON.stringify(sessionData));
              permalinkRequest.qId = item.QuoteBundle.details[i].quoteId;
            } else if (item.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.CONDO) {
              sessionStorage.setItem('condoSessionData', JSON.stringify(sessionData));
              permalinkRequest.qId = item.QuoteBundle.details[i].quoteId;
            } else if (item.QuoteBundle.details[i].productTypeId === QRP.PRODUCTS.RENTERS) {
              sessionStorage.setItem('renterSessionData', JSON.stringify(sessionData));
              permalinkRequest.qId = item.QuoteBundle.details[i].quoteId;
            }
            actions.goToBundleQuote(permalinkRequest, this.$store, this.$router, 'property');
          }
        }
      } else {        
        sessionStorage.setItem('flowType', item.ProductTypeId);
        actions.goToQuote(permalinkRequest, this.$store, this.$router);
      }
    },
    submitted() {
      this.newQuoteSubmit();
    },
    epicSubmit() {
      const baldwinQueryParams = JSON.parse(sessionStorage.getItem('epic'));
      if (baldwinQueryParams && Object.keys(baldwinQueryParams).length) {
        const that = this;
        this.$store.dispatch('setForceBindSuccessful', false);
        // set start time and page name for tracking purpose
        this.$store.dispatch('setStartTime');
        this.$store.dispatch('setPageActionName', 'CreateQuote');

        this.$validator.detach('zipcode'); // Detach/reattach ZIP code validation because Find Quote changes it
        this.$validator.detach(this.insuranceType.field_name);
        this.$validator.detach('emailOrPhone');
        this.$validator.detach('dob');

        this.$validator.attach({
          name: 'zipcode',
          rules: 'required|digits:5',
          getter: () => that.formData.zip,
        });
        this.$validator.attach({
          name: this.insuranceType.field_name,
          rules: 'required',
          getter: () => this.insuranceType.field_value,
        });

        this.$validator.validateAll().then((result) => {
          if (!result) {
            if (this.errors.has('insurance_type')) {
              document.getElementById('Auto').focus();
            } else if (this.errors.has('zipcode')) {
              this.$refs.zipcode.focus();
            }
            return;
          }
          console.log(baldwinQueryParams);
          axios.post('/quotes/epicimportquote', {
            ...baldwinQueryParams,
            productTypeId: this.insuranceType.field_value,
          }).then((response) => {
            sessionStorage.setItem('sessionData', JSON.stringify(response.data));
            sessionStorage.setItem('redirectedFromEpicImport', JSON.stringify(true));
            if (response.data.Errors.length > 0) {
              this.createQuoteErrs = response.data.Errors;
            } else {
              // log API response time through application into GA tool
              commonService.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'CreateQuoteAPI', 'Search');
              this.$store.dispatch('createQuote', response);
              this.$store.dispatch('setCurrentNav', response.data.Link);
              let routeName = commonService.getRouteName(response.data.Link);
              this.$router.replace(routeName);
            }
          }).catch((error) => {
            console.log(error);
            this.epicSubmitFailure = true;
            setTimeout(() => {
              this.epicSubmitFailure = false;
            }, 4000);
          });
        }).catch((err) => {
          console.log('Error', err);
          this.epicSubmitFailure = true;
          setTimeout(() => {
            this.epicSubmitFailure = false;
          }, 4000);
        });
      }
    },
    findQuote() {
      let that = this; // TODO: Use Vue's way of passing `this` down the scope chain
      this.$validator.detach('zipcode'); // Detach/reattach ZIP code validation because New Quote changes it
      this.$validator.detach('emailOrPhone');
      this.$validator.detach('insurance_type');
      this.$validator.detach('dob');
      this.$validator.attach({
        name: 'zipcode',
        rules: 'digits:5',
        getter: () => that.formData.zip,
      });
      if (this.formData.ep !== '') { // if email or phone field is entered then validate email or phone.
        if (this.formData.ep.indexOf('@') !== -1) {
          this.$validator.attach({
            name: 'emailOrPhone',
            rules: 'email',
            getter: () => that.formData.ep,
          });
        } else {
          this.$validator.attach({
            name: 'emailOrPhone',
            rules: { regex: /^(\d{3})-?(\d{3})-?(\d{4})$/ },
            getter: () => that.formData.ep,
          });
        }
      }
      this.$validator.attach({
        name: 'dob',
        rules: { date_format: 'MM/DD/YYYY', within_year_range: [108, 16, 'MM/DD/YYYY'] },
        getter: () => that.formData.dob,
      });
      /**
       * Test entire form against these submission validation scenarios:
       *
       * 1) Valid Last Name AND Valid ZIP Code
       * 2) Valid Date of Birth AND Valid ZIP Code
       * 3) Valid Phone Number
       * 4) Valid Email
       *
       * If at least one of these is true, then submit.
       * If not, then don't submit and display the custom error message.
       */
      /* eslint arrow-parens: [0] */
      this.$validator.validateAll().then(result => {
        let submissionValidationRulesPass = false;
        // All form elements must be valid before submission validation is tested against
        if (!result) {
          if (this.errors.has('emailOrPhone')) {
            this.$refs.emailOrPhone.focus();
          } else if (this.errors.has('insurance_type')) {
            document.getElementById('Auto').focus();
          } else if (this.errors.has('zipcode')) {
            this.$refs.zipcode.focus();
          } else if (this.errors.has('fname')) {
            this.$refs.fname.focus();
          } else if (this.errors.has('lname')) {
            this.$refs.lname.focus();
          } else if (this.errors.has('dob')) {
            document.getElementById('dob_masked').focus();
          }
          this.custom_error_message = '';
        } else
        // Scenario 1)
        if (that.formData.lname) {
          submissionValidationRulesPass = true;
        } else
        // Scenario 2)
        if (that.formData.dob && that.formData.zip) {
          submissionValidationRulesPass = true;
        } else

        // Scenario 3)
        // Scenario 4)
        if (that.formData.ep) {
          submissionValidationRulesPass = true;
        } else {
          /**
           * Submission validation is not valid, so let's check if there is a
           * custom error message according to their input. However, the messaging
           * does not pair exactly with the validation logic. This is by design.
           * The possible error message scenarios are:
           *
           * A) Valid First Name only
           * B) Valid Last Name only
           * C) Valid ZIP Code only
           * D) Valid Date of Birth only
           */
          /* eslint no-lonely-if:  */
          // Error Message Scenario A)
          if (that.formData.fname) {
            this.custom_error_message = 'You cannot search by First Name only. Please enter Last Name.';
          //  that.$refs.lname.focus();
          } else if (that.formData.lname) {
            // Error Message Scenario B)
           // that.custom_error_message = 'You cannot search by Last Name only. Please also enter Zip Code.';
           // that.$refs.zipcode.focus();
          } else if (that.formData.zip) {
            // Error Message Scenario C)
            that.custom_error_message = 'You cannot search by Zip code only. Please enter Last Name.';
            // that.$refs.lname.focus();
          } else if (that.formData.dob) {
            // Error Message Scenario D)
             that.custom_error_message = 'Error: You cannot search by Date of birth only. Please enter Last Name.';
            // that.$refs.zipcode.focus();
          } else {
            // No error message scenarios are true
            that.custom_error_message = 'At least one input field must be filled to search quotes.';
            that.$refs.emailOrPhone.focus();
          }
        }

        if (submissionValidationRulesPass) {
          if (this.insuranceType.field_value === QRP.PRODUCTS.HA_BUNDLE) {
            this.formData.productType = QRP.PRODUCTS.AUTO + ',' + QRP.PRODUCTS.HOME;
          } else if (this.insuranceType.field_value === QRP.PRODUCTS.CA_BUNDLE) {
            this.formData.productType = QRP.PRODUCTS.AUTO + ',' + QRP.PRODUCTS.CONDO;
          } else if (this.insuranceType.field_value === QRP.PRODUCTS.RA_BUNDLE) {
            this.formData.productType = QRP.PRODUCTS.AUTO + ',' + QRP.PRODUCTS.RENTERS;
          } else {
            this.formData.productType = this.insuranceType.field_value !== '' ? this.insuranceType.field_value : 0;
          }
          this.$store.dispatch('setStartTime');
          that.custom_error_message = '';
          fetchData.getSearchData(this.formData).then((data) => {
            if (data.data.length && (data.data[0].SessionId || (!data.data[0].SessionId && data.data[0].QuoteBundle))) {
              // log API response time through application into GA tool
              commonService.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'Search_API', 'Search');
              /* eslint-disable */
              this.searchResultData = data;
              this.showEmptyMsg = false;
            } else if (data.data.length && data.data[0].Errors.length) {
              this.showEmptyMsg = true;
              this.zeroRecMsg = data.data[0].Errors[0].Message;
            }

            this.$nextTick(() => {
              this.setSearchStickies();
            });
            this.$store.dispatch('setSearchResultParams', this.formData);
            commonService.gapRecordAnalytics('Search');
          });
        }
      });

      window.scrollTo(0, 0);
    },
    resetForm() {
      let self = this; // you need this because *this* will refer to Object.keys below`
      this.custom_error_message = ''; // Clear custom error messages (they are not set/cleared by the validator)
      this.masked_input_value = '';
      this.dob_masked_input_value = '';
      this.insuranceType.field_value = '';
      // Iterate through each object field, key is name of the object field`
      Object.keys(this.formData).forEach(function (key) {
        self.formData[key] = '';
      });
      sessionStorage.setItem('epic', null);
      sessionStorage.setItem('epicSuccessAlertWasShown', null);
      this.showEpicBehaviors = false;
    },
    getDateFormat(dateValue) {
      return moment(dateValue, 'YYYYMMDD').format('MMM D, YYYY');
    },
    getDayDifference(dateValue) {
      let start = moment(new Date());
      let end = moment(dateValue);
      return start.diff(end, 'days');
    },
    moment: function () {
      return moment();
    },
    importEpicData() {
      let baldwinQueryParams = JSON.parse(sessionStorage.getItem('epic'));
      if (baldwinQueryParams && Object.keys(baldwinQueryParams).length >= 4) {
        const requestParams = {
          url: '/quotes/epicimportclient',
          data: baldwinQueryParams,
        };

        this.$store.dispatch('setSimpleLoader', true);
        postData.getEpicImportSession(requestParams).then((response) => {
          this.formData.fname = response.data.FirstName;
          this.formData.lname = response.data.LastName;
          this.formData.zip = response.data.ZipCode;
          // eslint-disable-next-line
          if (response.data.hasOwnProperty('ProductTypeId') && response.data.ProductTypeId > -1) {
            this.insuranceType.field_value = response.data.ProductTypeId;
          }
          this.showEpicBehaviors = true;

          if (JSON.parse(sessionStorage.getItem('epicSuccessAlertWasShown')) === false) {
            this.epicSuccess = true;
            sessionStorage.setItem('epicSuccessAlertWasShown', JSON.stringify(true));
          }
          this.$store.dispatch('setSimpleLoader', false);
          setTimeout(() => {
            this.epicSuccess = false;
          }, 4000);
        }).catch((error) => {
          this.$store.dispatch('setSimpleLoader', false);
          this.epicFailure = true;
          console.log('error', error);
          setTimeout(() => {
            this.epicFailure = false;
          }, 4000);
          sessionStorage.setItem('epic', null);
          sessionStorage.setItem('epicSuccessAlertWasShown', JSON.stringify(false));
        });
      }
    },    
  },
  components: {
    mainHeader: Header,
    mainFooter: Footer,
    FormBlock,
    InputProductType,
  },
  /* eslint-disable */
  created() {
    // Redirect to quote if there is one present in URL
    if (this.qId) {
      this.processQuote({
        qId: this.qId,
        loc: this.loc,
      });
    }

    /**
     * check if user redirected from admin section
     */
    // if (this.$route.query.action && this.$route.query.action === 'newQuote') {
    //   this.formData.ep = this.$route.query.ep;
    //   this.insuranceType.field_value = this.$route.query.pt;
    //   this.formData.zip = this.$route.query.zip;
    // }
    let searchParams = this.$store.getters.getSearchParams;
    if (searchParams) {
      this.formData.ep = searchParams.ep;
      this.formData.zip = searchParams.zip;
      this.insuranceType.field_value = searchParams.productType;
      this.$store.dispatch('setStartTime');
      this.$store.dispatch('setPageActionName', 'searchResult');
      fetchData.getSearchData(searchParams).then((data) => {
        if (data.data.length && (data.data[0].SessionId || (!data.data[0].SessionId && data.data[0].QuoteBundle))) {
          // log API response time through application into GA tool
          commonService.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'Search_API', 'Search');
          this.searchResultData = data;
          this.showEmptyMsg = false;
        } else if (data.data.length && data.data[0].Errors.length) {
          this.showEmptyMsg = true;
          this.zeroRecMsg = data.data[0].Errors[0].Message;
        }

        this.$nextTick(() => {
          this.setSearchStickies();
        });
        commonService.gapRecordAnalytics('Search');
      });
    }

    this.userAgency = sessionStorage.getItem('userAgency'); // TODO: Detect authenticated session

    /* eslint no-undef: */
    /* eslint prefer-template:  */
    gtag('config', '<%= process.env.GAID %>', { page_path: '/search' });
  },
  mounted() {
    ///////////////////////
    User.init().then((res) => {
      this.productButtonsData = Object.create(this.insuranceType);
      const productOrder = [1, 21, 18, 12, QRP.PRODUCTS.HA_BUNDLE, QRP.PRODUCTS.CA_BUNDLE, QRP.PRODUCTS.RA_BUNDLE];
      this.userProfileData.firstName = sessionStorage.getItem('userFirstName');
      this.userProfileData.lastName = sessionStorage.getItem('userLastName');
      console.log('this.userProfileData', this.userProfileData);
      if(res.productAccess.includes(QRP.PRODUCTS.AUTO) && res.productAccess.includes(QRP.PRODUCTS.HOME)) {
        res.productAccess.push(QRP.PRODUCTS.HA_BUNDLE);//TODO
      }
      if(res.productAccess.includes(QRP.PRODUCTS.CONDO) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.CA_BUNDLE);//TODO
      }
      if(res.productAccess.includes(QRP.PRODUCTS.RENTERS) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.RA_BUNDLE);//TODO
      }
      if (typeof res.productAccess === 'object') {
        for (let i = 0; i < productOrder.length; i += 1) {
          if (res.productAccess.includes(productOrder[i])) {
            this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
          }
        }
      } else {
        const productAccessArray = res.productAccess.split(',');

        for (let i = 0; i < productOrder.length; i += 1) {
          if (productAccessArray.includes(productOrder[i])) {
            this.productButtonsData.values.push(filters.search_products_with_icons[productOrder[i]]);
          }
        }
      }

      if (res.productAccess.length === 1) {
        this.productButtonsData.field_value = res.productAccess[0]; // the single product is set as the selected one
      }

      this.insuranceType = [];
      this.insuranceType = this.productButtonsData;

      console.log('importEpicData about to run');
      this.importEpicData();
    });
    /////////////////////////
    if (this.forceBindData) {
      this.$store.dispatch('setForceBindSuccessful', true);
    }

    this.setSearchStickies();

    this.masked_input = this.formData.phone; // Populate phone input value
    this.dob_masked_input = this.formData.dob; // Populate dob input value

    // TODO: Abstract to helper function
    const appContainer = document.getElementById('app-container');

    if (appContainer) {
      appContainer.classList.add('admin-nav');
      appContainer.classList.remove('stacked-nav');
    }
  },
  beforeDestroy() {
    // TODO: Abstract to helper function
    const appContainer = document.getElementById('app-container');

    if (appContainer) {
      appContainer.classList.remove('admin-nav');
      appContainer.classList.remove('stacked-nav');
    }
  },
};
</script>

<style scoped lang="scss">

/***Results***/
.mb-row-custom{
  margin-bottom: 2px;
}
  /***Results-Row Hover***/
  .mb-row-custom:hover{
    background: #FFFFFF !important;
  }
.row-auto-bg{
  background:$var-auto-bg;
}
.row-home-bg{
  background:$var-home-bg;
}
.row-condo-bg{
  background:$var-condo-bg;
}
.row-renter-bg{
  background: $var-renter-bg;
}
.row-home-auto-bundle-bg{
  background: $var-home-auto-bundle-bg;
}
.row-condo-auto-bundle-bg{
  background: $var-condo-auto-bundle-bg;
}
.row-renter-auto-bundle-bg{
  background: $var-renter-auto-bundle-bg;
}
.search-row-common{
  font-size: 1rem !important;
  color: #ffffff;
  text-align: center;
}
.search-row-common.auto{
  background: $var-color-auto;
}
.search-row-common.home{
  background: $var-color-home;
}
.search-row-common.condo{
  background:$var-color-condo;
}
.search-row-common.renter{
  background: $var-color-renter;
}
.search-row-common.home-auto-bundle{
  background: $var-color-home-auto-bundle;
}
.search-row-common.condo-auto-bundle{
  background: $var-color-condo-auto-bundle;
}
.search-row-common.renter-auto-bundle{
  background: $var-color-renter-auto-bundle;
}
.mx-w-ico{
  max-width: 40px !important;
}
.ins-type-disp{
  font-size: 0.75rem !important;
}


.border-blue{
  border: 1px solid #333399;
}

.container-fluid{
  margin-top: 3rem;
}

h1{
  margin: 0;
  font-size: 0.75rem;
  line-height: 1.25rem;
}

label{
  margin-bottom: 0.125rem;
  font-size: 0.75rem;
  font-weight: 600;
}
.border-blue{
  border: 1px solid #003366 !important;
}
.quote-result:nth-child(even){
  background: #F9F9F9;
}

.quote-result:hover{
  background: #EEEEEE;
}

#main-footer {
  padding-top: 0.9rem;
  padding-left: 0.8rem;
  margin-bottom: 1rem !important;
  font-size: 0.625rem;
}

#search-results-list-header {
  z-index: 1000;
}

.head-stick-head {
  position: fixed;
  z-index:100;
  width:66% !important;
}

.head-stick-body {
  margin-top:58px;
  width: 100%;
}

#search-results-stick-head-columns,
#search-results-stick-body {
  width: 100%;
}

.search-results-all-fixed {
  position: fixed;
  width: 66%;
}

.fa-exclamation-triangle{
  color:#BB0000;
  font-size:1rem;
  line-height: 27px;
  margin-left:5px;
}
.btn.btn-success.epic-submit {
  background-color: #2E7B32;
}
.btn.btn-success.epic-submit:hover {
  background-color: white;
  border-color: #2E7B32;
  color: #2E7B32;
}
.epic-success {
  position: fixed !important;
  top: 1rem;
  left: 35%;
  width: 30%;
  height: auto;
  z-index: 1100;
  color: #1A1A1A;
  background-color: #ECF8EB;
  border: 2px solid #2E7B32 !important;
  .epic-alert-icon {
    font-size: 25px;
    color: #2E7B32;
  }
  h4 {
    font-size: 20px;
  }
}
.epic-failure {
  position: fixed !important;
  top: 1rem;
  left: 35%;
  width: 30%;
  height: auto;
  z-index: 1100;
  color: #1A1A1A;
  background-color: #F5D9D9;
  border: 2px solid #BB0000 !important;
  .epic-alert-icon {
    font-size: 25px;
    color: #BB0000;
  }
  h4 {
    font-size: 20px;
  }
}
.add-scroll-y {
  overflow-y: auto !important;
  height: calc(100vh - 74px);
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue?46fb2ff6